/**
 * @fileOverview This is the base class for all the other metric classes.
 * @name VU.js
 * @author Min Zhu
 * @license MIT
 */
import React, { Component } from "react";
import { Float, Core } from "@cnsit/js";
import "./VU.css";

export class VU extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isReadonly: props.readonly,
      value:
        props.value instanceof Float ? props.value : new Float(props.value),
      scales: props.scales,
      scaleIndex: props.scaleIndex,
      unit: props.unit,
      size: props.size,
      caption: props.caption,
      id: props.id,
      message: props.message,
      precision: Core.isNumber(props.precision) ? props.precision : 5
    };
    this.onValueChange = this.onValueChange.bind(this);
    this.onUnitChange = this.onUnitChange.bind(this);
    this.unify = this.unify.bind(this);
  }
  componentDidMount() {
    console.log(this.unify());
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    console.log(this.state.unit + " componentDidUpdate", this.props.value);
    if (
      this.props.value instanceof Float &&
      this.props.value !== prevProps.value
    ) {
      let factor = Float.getBeautifyFactor(this.props.value);
      let i = 0;
      // 下面先找到基准单位，也就是 '' 的单位。
      for (i = 0; i < this.state.scales.length; i++) {
        if (this.state.scales[i] === "") {
          break;
        }
      }
      // 新的美化单位的索引是从基准单位开始，加上 factor
      let newIndex = i + factor;
      try {
        if (newIndex < 0 || newIndex >= this.state.scales.length) {
          // 此时的单位已经超出组件定义的范围，直接设置默认的标准单位。
          this.setState({
            scaleIndex: i,
            value: this.props.value,
            message: ""
          });
        } else {
          this.setState({
            scaleIndex: newIndex,
            value: new Float({
              int: this.props.value.getInt(),
              exp: this.props.value.getExp() - 3 * factor
            }),
            message: ""
          });
        }
      } catch (ex) {
        this.setState({ message: ex });
      }
    }
  }
  /**
   * Unify value and scale into the base level.
   */
  unify() {
    let scale = this.state.scales[this.state.scaleIndex];
    let value = {
      int: this.state.value.getInt(),
      exp: this.state.value.getExp() + Float.getExpFromScale(scale)
    };
    return new Float(value);
  }
  onValueChange(e) {
    console.log(this.state.unit, "onValueChange", e.target.value);
    if (Core.isNumber(e.target.value)) {
      if (this.state.value.equal(e.target.value)) {
        console.log(this.state.unit, "equal");
        return;
      }
      this.setState({ value: new Float(e.target.value), message: "" }, () => {
        console.log(this.state.unit, "onValueChange - setState");
        if (Core.isFunction(this.props.onChange))
          this.props.onChange(this.state.id, this.unify());
      });
    } else {
      this.setState({ message: "请输入数值！" });
    }
  }
  onUnitChange(e) {
    console.log(this.state.unit, "onUnitChange", e.target.value);
    this.setState({ scaleIndex: e.target.selectedIndex, message: "" }, () => {
      console.log(this.state.unit, "onUnitChange - setState");
      if (Core.isFunction(this.props.onChange))
        this.props.onChange(this.state.id, this.unify());
    });
  }
  dispUnit() {
    return `${this.state.scales[this.state.scaleIndex]}${this.state.unit}`;
  }

  render() {
    let caption = Float.isValid(this.state.caption) ? (
      <div className="caption">{this.state.caption}</div>
    ) : (
      <></>
    );
    let message = Float.isValid(this.state.message) ? (
      <div className="message">{this.state.message}</div>
    ) : (
      <></>
    );
    if (this.state.isReadonly) {
      return (
        <div className="vu">
          {caption}
          <div className="value">
            {this.state.value.unpack(this.state.precision)}
          </div>
          <div className="unit">{this.dispUnit()}</div>
          {message}
        </div>
      );
    } else {
      let units = this.state.scales.map((u) => {
        let v = `${u}${this.state.unit}`;
        return (
          <option value={v} key={v}>
            {v}
          </option>
        );
      });
      return (
        <div className="vu">
          {caption}
          <input
            type="text"
            className="value"
            defaultValue={this.state.value.unpack()}
            size={this.state.size}
            onChange={this.onValueChange}
          />
          <select
            className="unit"
            defaultValue={this.dispUnit()}
            onChange={this.onUnitChange}
          >
            {units}
          </select>
          {message}
        </div>
      );
    }
  }
}
